module.exports = __webpack_public_path__ + "img/suitability3.396d78a8.png";